var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-container",
    [
      _c(
        "app-section",
        [_c("app-title", [_vm._v(_vm._s(_vm.$ct("title-problem")))])],
        1
      ),
      _c(
        "app-section",
        [
          _c("app-text", {
            directives: [
              {
                name: "safe-html",
                rawName: "v-safe-html",
                value: _vm.$ct("text-problem"),
                expression: "$ct('text-problem')",
              },
            ],
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }